function ConditionIndicatorsListController(
  ConditionService,
  eventService,
  chartColorService,
  userService,
  config
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.aadEnabled = config.aadEnabled;
    ctrl.optionsMenu = {
      startDateOpened: false,
      endDateOpened: false,
      openStartDatePicker: function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = true;
        ctrl.optionsMenu.endDateOpened = false;
      },
      openEndDatePicker: function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        ctrl.optionsMenu.startDateOpened = false;
        ctrl.optionsMenu.endDateOpened = true;
      },
      datePickerFormat: 'dd.MM.yyyy',
      dateOptions: {
        startingDay: 1,
        showWeeks: false,
      },
    };

    ctrl.selection = {
      startDate: null,
      endDate: new Date().toISOString(),
    };

    ctrl.hasEditCI = userService.hasEditCI();
    if (ctrl.chartVisible) {
      const ciType = ctrl.ciType;
      ctrl.openGraph(ciType.ciNumber, ciType.name, ciType);
    }
  };

  ctrl.openGraph = async (ciNumber, name, config) => {
    ctrl.onDisplayGraph({
      $event: true,
    });

    ctrl.dataLoading = true;

    ctrl.selection.startDate = DateTime.now().startOf('day').minus({days: 30}).toJSDate();
    ctrl.selection.endDate = DateTime.now().endOf('day').toJSDate();
    const params = {
      assetId: ctrl.asset.id,
      ciNumber: ciNumber,
      start: ctrl.selection.startDate.toISOString(),
      end: ctrl.selection.endDate.toISOString(),
    };

    const alertParams = {
      assetId: ctrl.asset.id,
      ciNumber: ciNumber,
      start: ctrl.selection.startDate.toISOString(),
      end: ctrl.selection.endDate.toISOString()
    }

    // Fetch CI values, aggregation data and AAD alerts
    ctrl.graphData = await ConditionService.getGraphDataForTimeRange(params);
    ctrl.aggregationData = await ConditionService.getAggregationsForTimeRange(params);

    if (ctrl.aadEnabled === 'true') {
      ctrl.conditionAlerts = mapAlerts(await ConditionService.getAlertsForCI(alertParams));
    }

    ctrl.activeCINumber = ciNumber;
    ctrl.activeCIName = name;
    ctrl.splineConfigDefaults(config);
    ctrl.configureDataSeries(ctrl.graphData, ctrl.aggregationData, ctrl.conditionAlerts);
    ctrl.dataLoading = false;
  };

  ctrl.openConfig = ciNumber => {
    ctrl.onDisplayConfig({
      $event: {
        config: ciNumber,
      }
    });
  };

  ctrl.splineConfigDefaults = config => {
    const yAxisMin = resolveYAxisMin(config, ctrl.graphData);

    ctrl.config = {
      chart: {
        type: 'line',
        marginRight: 100,
        zoomType: 'x',
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 1,
        crosshair: {
          snap: true,
        },
      },
      yAxis: [{
        min: yAxisMin,
        minRange: config.minRange,
        allowDecimals: false,
        plotLines: [
          {
            color: '#ffac00', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.warningThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Warning Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
          {
            color: '#ff2621', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.alarmThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Alert Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
        ],
      }],
      legend: {},
      series: [],
    };
    eventService.broadcast('reload');
  };

  const resolveYAxisMin = (ciConfig, graphData) => {
    const axisMinimum = Number.parseFloat(ciConfig.axisMinimum);
    if (Number.isFinite(axisMinimum)) {
      return axisMinimum;
    }

    const values = (graphData || [])
      .map(item => Number.parseFloat(item.value))
      .filter(value => Number.isFinite(value));

    if (!values.length) {
      return 0;
    }

    const minValue = Math.min(...values);
    return Math.min(0, minValue);
  };


  // Create series and map data
  ctrl.configureDataSeries = (graphData, aggregationData, alerts) => {
    let seriesCount = 1;

    // CI VALUES
    ctrl.config.series = [
      {
        id: seriesCount++,
        count: 1,
        zIndex: 0,
        visible: !aggregationData.length,
        name: ctrl.activeCIName,
        data: _getData(graphData),
        tooltip: {
          formatter: function() {
            const dateStr = DateTime.fromISO(this.x)
              .setLocale('fi')
              .toFormat('DDDD t');
            return (
              '<span style="font-size: 11px">' +
              dateStr +
              '</span><br/>' +
              '<span>' +
              this.activeCIName +
              '</span><br/>' +
              '<span style="color:' +
              this.color +
              '">\u25CF</span> ' +
              'Measurement value' +
              ': <b>' +
              this.y +
              '</b>'
            );
          },
          shared: false,
        }
      }
    ];

    // AAD ALERT DATA
    if (ctrl.aadEnabled === 'true') {
      for (let [key, value] of alerts) {
        const seriesConfig = {
          count: 1,
          id: seriesCount++,
          borderColor: 'black',
          type: 'xrange',
          pointWidth: 4,
          borderWidth: 0.1,
          marker: {
            enabled: true,
            symbol: 'circle'
          },
          name: value[0].alertType,
          zIndex: 5,
          data: _getAlertData(value),
          tooltip: {
            pointFormatter: function() {
              const startTime = DateTime.fromISO(this.x)
                .setLocale('fi')
                .toFormat('DDDD t');
              return (
                '<span style="color:' + this.color + '">\u25CF</span> ' +
                '<b> Alert type: </b>' +
                this.alertType +
                '<br/><span style="color:' + this.color + '">\u25CF</span> ' +
                '<b> Start time: </b>' +
                startTime +
                '<br/><span style="color:' + this.color + '">\u25CF</span> ' +
                '<b> Reset time: </b>' +
                this.resetTime
              );
            },
            shared: false,
          }
        }
        ctrl.config.series.push(seriesConfig);
      }
    }
  
    // AGGREGATION DATA
    aggregationData.forEach(function (aggregation) {
      const seriesConfig = {
        id: seriesCount++,
        count: 1,
        cursor: 'pointer',
        zIndex: 1,
        visible: aggregation.aggregation === 'MEDIAN',
        name: aggregation.aggregation,
        marker: {
          enabled: true,
        },
        data: _getData(aggregation.data),
        tooltip: {
          formatter: function() {
            const dateStr = DateTime.fromISO(this.x)
              .setLocale('fi')
              .toFormat('DDDD t');
            return (
              '<span style="font-size: 11px">' +
              dateStr +
              '</span><br/>' +
              '<span>' +
              this.type +
              '</span><br/>' +
              '<span style="color:' +
              this.color +
              '">\u25CF</span> ' +
              'Aggregation value' +
              ': <b>' +
              this.y +
              '</b>'
            );
          },
          shared: false,
        }
      }
      ctrl.config.series.push(seriesConfig);
    });

    chartColorService.fillDataWithColors(ctrl.config.series);
    ctrl.config.series[0].color = 'rgba(70,130,180, 0.75)';
  };

  const mapAlerts = alerts => {
    const alertMap = new Map(alerts.map(alert => [ alert.alertType, [] ]));
    alerts.forEach(function(alert) {
      alertMap.get(alert.alertType).push(alert);
    });
    return alertMap;
  }

  const convertToMillis = timestamp => {
    return new Date(timestamp).getTime();
  };

  const _getData = series => {
    return series.map(item => {
      return [convertToMillis(item.timestamp), parseFloat(item.value)];
    });
  };

  const _getAlertData = alerts => {
    return alerts.map(item => {
      return {
        x: convertToMillis(item.alertTime), 
        x2: item.resetTime !== null ? convertToMillis(item.resetTime) : convertToMillis(new Date()),  
        resetTime: item.resetTime !== null ? DateTime.fromISO(item.resetTime).setLocale('fi').toFormat('DDDD t') : '-', 
        y: ctrl.yMax(), 
        alertType: item.alertType 
      };
    });
  };

  ctrl.yMax = () => {
    const max = Math.max.apply(Math, ctrl.graphData.map(function(o) { return parseFloat(o.value); }));
    return parseFloat(max);
  }


  // Graph update functionality
  ctrl.updateGraph = async (start, end) => {
    if (start !== null) {
      start.setHours(0,0,0);
    }

    if (end !== null) {
      end.setHours(23,59,59);
    }

    const params = {
      assetId: ctrl.asset.id,
      ciNumber: ctrl.activeCINumber,
      start: start,
      end: end,
    };

    ctrl.dataLoading = true;

    if (start === null && end === null) {
      const date = DateTime.utc().endOf('day').toISO();
      ctrl.selection.endDate = date;
      params.end = date;
      ctrl.graphData = await ConditionService.getGraphDataBeforeDate(params);
      ctrl.aggregationData = await ConditionService.getAggregationsBeforeTime(params);
    } else if (start === null) {
      ctrl.graphData = await ConditionService.getGraphDataBeforeDate(params);
      ctrl.aggregationData = await ConditionService.getAggregationsBeforeTime(params);
    } else if (end === null) {
      ctrl.graphData = await ConditionService.getGraphDataAfterDate(params);
      ctrl.aggregationData = await ConditionService.getAggregationsAfterTime(params);
    } else {
      ctrl.graphData = await ConditionService.getGraphDataForTimeRange(params);
      ctrl.aggregationData = await ConditionService.getAggregationsForTimeRange(params);
    }

    const alertParams = {
      assetId: ctrl.asset.id,
      ciType: ctrl.activeCINumber,
      start: params.start,
      end: params.end
    }

    if (ctrl.aadEnabled === 'true') {
      ctrl.conditionAlerts = mapAlerts(await ConditionService.getAlertsForCI(alertParams));
    }

    const activeCi = ctrl.asset.ci_values.find(obj => obj.ciNumber === ctrl.activeCINumber);
    const ciConfig = activeCi?.config;
    if (ciConfig) {
      ctrl.config.yAxis[0].min = resolveYAxisMin(ciConfig, ctrl.graphData);
    }
    
    ctrl.configureDataSeries(ctrl.graphData, ctrl.aggregationData, ctrl.conditionAlerts);
    ctrl.dataLoading = false;
  };


  // Update functions when CI configuration is being changed
  eventService.on('update-ci-list', function(event, config) {
    updateCiConfig(config);
  });

  const updateCiConfig = config => {
    const index = ctrl.asset.ci_values.findIndex((obj => obj.ciNumber === config.ciNumber));
    ctrl.asset.ci_values[index].unit = config.unit;
    ctrl.asset.ci_values[index].name = config.name;
    ctrl.asset.ci_values[index].config = ctrl.asset.ci_values[index].config || {};
    ctrl.asset.ci_values[index].config.warningThreshold = config.warningThreshold;
    ctrl.asset.ci_values[index].config.alarmThreshold = config.alarmThreshold;
    ctrl.asset.ci_values[index].config.minRange = config.minRange;
    ctrl.asset.ci_values[index].config.axisMinimum = config.axisMinimum;
  };
}

angular
  .module('modalDirectives')
  .controller('ConditionIndicatorsListController', ConditionIndicatorsListController);
